module.exports = __webpack_public_path__ + "static/media/shoulderbone.706cfbd0.png";